import { CSSProperties } from "react";

export const bulkRunBlocksBlock: CSSProperties = {
  paddingTop: "10px",
  borderBottom: "1px solid #c9d1d5",
  overflowX: "hidden",
};
